import React from "react";
import styled from "styled-components";
import { getCreatedAtDescriptionFromDate } from "@sonder/ui/source/styled/components/Comment";
import {
  CommentContent,
  CommentCreatedAt,
  Comment as CommentFragment,
  CommentGutter,
} from "@sonder/ui/source/styled/fragments/Comment";
import { colors } from "@sonder/ui/source/styled/theme";

const StyledCommentFragment = styled(CommentFragment)`
  align-items: center;
`;

const ActivityGutter = styled(CommentGutter)`
  align-self: stretch;
  border-right: 2px solid ${colors.blue7};
  box-sizing: border-box;
  margin-right: 1rem;
  min-height: 2rem;
`;
const ActivityContent = styled(CommentContent)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

interface ActivityProps {
  body: React.ReactNode;
  children?: React.ReactNode;
  createdAt: string;
}
export const Activity = ({ body, children, createdAt }: ActivityProps) => {
  return (
    <StyledCommentFragment>
      <ActivityGutter />
      <ActivityContent>
        {children && <span>{children}</span>}
        <span>
          {body}
          <CommentCreatedAt>
            {getCreatedAtDescriptionFromDate(createdAt)}
          </CommentCreatedAt>
        </span>
      </ActivityContent>
    </StyledCommentFragment>
  );
};
